import { createHeaders } from "./createHeaders";
import { createRequest } from "./createRequest";

const FAKE_API_URL = "https://fakestoreapi.com";

export { FAKE_API_URL, createHeaders, createRequest };
